const URL = "https://azurecoinz.com";
export default {
    URL
};
